import { createRoot } from 'react-dom/client';
import { BtnDeep } from './Button';

class CustomAddressRenderer {
  element;

  constructor(props: any) {
    this.element = document.createElement('div');
    const root = createRoot(this.element);

    const { onClickMapView } = props.columnInfo.renderer.options;
    const { address1, latitude, longitude } = props.value;
    // const { rowKey } = props;

    root.render(
      <div className='address-wrap'>
        <div className='address-title'>{address1}</div>
        {onClickMapView && latitude !== '' && longitude !== '' && (
          <BtnDeep type='button' onClick={(e) => onClickMapView(e, props.value)}>
            지도보기
          </BtnDeep>
        )}
      </div>
    );
  }

  getElement() {
    return this.element;
  }
}
export default CustomAddressRenderer;
